import type {NodeSchedule} from 'src/types/node-schedule';
import type {ChatbotWhatsappState} from 'src/types/chatbot-whatsapp';
import type {Dispatch, ThunkAction} from 'src/reducers';
import * as reduxApiBff from 'src/utils/redux-api-bff';
import {parseChatbotWhatsapp} from 'src/utils/chatbot-whatsapp';


export const RECEIVE_CHATBOT_WHATSAPP_INFO = 'chatbot-whatsapp/receive';
export const UPDATE_CHATBOT_WHATSAPP_INFO = 'chatbot-whatsapp/update';
export const UPDATE_NODE_SCHEDULE = 'chatbot-whatsapp/update-node-schedule';
export const RESET = 'chatbot-whatsapp/reset';

type UpdateChatbotWhatsappInfoPayload = Partial<ChatbotWhatsappState>;

type ReceiveChatbotWhatsappInfoAction = {
  type: 'chatbot-whatsapp/receive';
  payload: ChatbotWhatsappState;
};

type UpdateChatbotWhatsappInfoAction = {
  type: 'chatbot-whatsapp/update';
  payload: UpdateChatbotWhatsappInfoPayload;
};
type UpdateNodeScheduleAction = {
  type: typeof UPDATE_NODE_SCHEDULE;
  payload: Partial<NodeSchedule>;
};
type ResetStateAction = {
  type: 'chatbot-whatsapp/reset';
};

export type ChatbotWhatsappAction =
  | ReceiveChatbotWhatsappInfoAction
  | UpdateChatbotWhatsappInfoAction
  | UpdateNodeScheduleAction
  | ResetStateAction;

export const reset = (): ResetStateAction => ({type: RESET});

export const receiveChatbotWhatsappNode = (
  payload: ChatbotWhatsappState,
): ReceiveChatbotWhatsappInfoAction => ({
  type: RECEIVE_CHATBOT_WHATSAPP_INFO,
  payload,
});

export const updateChatbotWhatsappInfo = (
  payload: UpdateChatbotWhatsappInfoPayload,
): UpdateChatbotWhatsappInfoAction => ({
  type: UPDATE_CHATBOT_WHATSAPP_INFO,
  payload,
});
export const updateNodeSchedule = (
  payload: Partial<NodeSchedule>,
): UpdateNodeScheduleAction => ({
  type: UPDATE_NODE_SCHEDULE,
  payload,
});

export const getChatbotWhatsappTaskNode: (
  node_id: string,
) => ThunkAction<unknown> = (node_id) => async (dispatch: Dispatch) => {
  const fetchedNodeResponse = await dispatch(
    reduxApiBff.get(`node/composite`, {
      node_id,
    }),
  );
  const parsedChatbotWhatsappNode = parseChatbotWhatsapp(
    fetchedNodeResponse.body,
  );
  return dispatch(updateChatbotWhatsappInfo(parsedChatbotWhatsappNode));
};
